import React from 'react';

export default function ChatButton() {
    const onChatButtonClick = () => {
        window.insyncSetChatEnv.openChat('OpenChat');
    };
    return (
        <span style={{ display: 'block', zIndex:"9999" }} id="insync-chat-icon-id" onClick={onChatButtonClick}>
            <img alt="chat-button" src="https://d2c0xhqyhmtkod.cloudfront.net/chat_icon.png" />
        </span>
    );
}
